<!--档案管理-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-if="showMode==='list'">
            <div class="model-container">
                <div :class="activeItem==='1'?'model-item model-active':'model-item'" @click="handleActiveChange('1')">档案审核</div>
            </div>
            <!--档案审核-->
            <div class="bre9e" v-show="activeItem==='1'">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 145px)"
                          :data="dataList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="130" align="center" label="档案提交时间" prop="fillSubTime">
                        <template #default="scope">
                            <div>
                                {{ timestampToTime(scope.row.fillSubTime) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="教师姓名" align="center" width="80"  prop="trueName">
                        <template #default="scope">
                            {{ scope.row.trueName }}
                        </template>
                    </el-table-column>
                    <el-table-column label="教师性别" align="center" width="80"  prop="gender">
                        <template #default="scope">
                            <div v-if="scope.row.gender===0">男</div>
                            <div v-if="scope.row.gender===1">女</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="联系方式" align="center" width="120"  prop="username">
                    </el-table-column>
                    <el-table-column label="所属学校" align="center" width="200"  prop="orgName">
                        <template #default="scope">
                            {{ scope.row.orgName }}
                        </template>
                    </el-table-column>
                    <el-table-column width="200" align="center" label="学段•年级•学科">
                        <template #default="scope">
                            <el-text>
                                {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.gradeName?scope.row.gradeName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                            </el-text>
                        </template>
                    </el-table-column>
                    <el-table-column width="80" fixed="right" align="center" label="档案状态" prop="isCheck">
                        <template #default="scope">
                            <div v-if="scope.row.checkStatus===1" class="tab-dfp">待审核</div>
                            <div v-if="scope.row.checkStatus===2" class="tab-shtg">已通过</div>
                            <div v-if="scope.row.checkStatus===3" class="tab-shjj">已驳回</div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" align="center" width="100">
                        <template #default="scope">
                            <el-button type="primary"
                                       style="background-color: #3b82f6;color: #fff"
                                       v-if="scope.row.checkStatus===1"
                                       size="small" @click="archiveCheck(scope.row,0)">审核</el-button>
                            <el-button type="primary"
                                       v-if="scope.row.checkStatus!==1"
                                       size="small" @click="archiveCheck(scope.row,1)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- 档案审核 -->
        <div class="detail-mode" v-if="showMode==='archiveCheck'">
            <archive-check :archive-user="archiveUser"
                           :archive-status="archiveStatus"
                           :is-view="isView"
                           @change-active-mode="changeActiveModel"/>
        </div>
    </div>
</template>

<script>
import {timestampDate, timestampToTime} from "@/utils/date";
import {queryDict} from "@/api/admin/public";
import { archiveManagerCheckList } from '@/api/admin/archive';
import archiveCheck from "@/components/homeManager/archive/archiveCheck.vue";

export default {
    name:'archiveManager',
    computed: {},
    components:{
        archiveCheck
    },
    props:{
        itemMode:{
            type: String,
            default:'page'
        },
    },
    watch:{
        itemMode(newValue,oldValue){
            this.showMode = newValue;
        },
    },
    mounted() {
        this.getCheckList();
    },
    data() {
        return {
            listMode:'list',
            checkMode:'archiveCheck',
            showMode:'list',
            activeItem:'1',
            timestampDate,
            timestampToTime,
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            dataList:[],
            topicId:'',
            subTopicId:'',
            subTopicList:[],
            managerSubTopicList:[],
            signList:[],
            signId:'',
            signStatus:1,
            archiveUser:'',
            archiveStatus:0,
            isView:0,

        }
    },
    methods: {
        getQueryDict() {
            queryDict({ code: 'topic_classify' }).then(res => {
                this.topicClassifyList = res.data.data;
            })
        },
        getCheckList(){
            archiveManagerCheckList().then(res => {
                this.dataList = res.data.data;
            });
        },
        handleActiveChange(activeItem){
            this.activeItem = activeItem;
            if (activeItem==='1'){
                this.getCheckList()
            }
        },
        archiveCheck(row,isView){
            this.archiveUser = row.userId;
            this.archiveStatus = row.checkStatus;
            this.isView = isView;
            this.showMode = this.checkMode;
            this.$emit('change-mode',this.showMode);
        },
        //子组件传值
        changeActiveModel(model,activeItem){
            this.showMode = model;
            this.activeItem = activeItem;
            this.$emit('change-mode',this.showMode, 1);
            if (activeItem==='1'){
                this.getCheckList()
            }
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
    //font-family: "黑体",serif;
}
.page-mode{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.model-container{
    width: 100%;
    height: 50px;
    display: flex;
    padding-left: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #3b62f8;
}
.model-item{
    width: auto;
    padding: 0 10px 0 10px;
    height: 28px;
    color: #3b62f8;
    border: 1px solid #3b62f8;
    line-height: 28px;
    margin-right: 20px;
    font-size: 14px;
    border-radius: 6px;
    margin-top: 11px;
    cursor: pointer;
    font-weight: bold;
}
.model-active{
    color: #fff!important;
    border: 1px solid #3b62f8!important;
    background-color: #3b62f8!important;
}


.tab-dfp{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #ffbf6b
}
.tab-dsh{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #4095e5
}
.tab-shtg{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #81b337;
}
.tab-shjj{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #bd3124;
}

.status-info-bm{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-kt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #ffbf6b;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-zq{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #bd3124;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-jt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #81b337;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
</style>